import { create } from "zustand";
import { dataFetcher } from "../core/dataFetcher";

interface SDKConfigState {
  eoaAddress: string | null;
  apiKey: string | null;
  baseUrl: string | null;
  apiPath: string | null;
  isInitialized: boolean;
  setConfig: (config: {
    eoaAddress: string;
    apiKey: string;
    baseUrl?: string;
    apiPath?: string;
  }) => void;
  reset: () => void;
}

export const useSDKConfigStore = create<SDKConfigState>((set, get) => ({
  eoaAddress: null,
  apiKey: null,
  baseUrl: null,
  apiPath: null,
  isInitialized: false,

  setConfig: (config) => {
    // Reset previous state
    get().reset();

    // Set new config
    set({
      eoaAddress: config.eoaAddress,
      apiKey: config.apiKey,
      baseUrl: config.baseUrl || "https://dev.console.fi",
      apiPath: config.apiPath || "/v1/vendor",
      isInitialized: true,
    });

    // Note: Data fetching will be triggered after authentication is complete
  },

  reset: () => {
    set({
      eoaAddress: null,
      apiKey: null,
      baseUrl: null,
      apiPath: null,
      isInitialized: false,
    });

    // Reset data stores
    dataFetcher.reset();
  },
}));
